import styled from "styled-components";
import { Typography } from "@mui/material";
import { colors } from "../../../theme";

export const StyledMenuTypography = styled(Typography)`
    font-size: 15px;
    color: ${colors.neutral08};
`;
